module.exports = "data:image/png;base64,bW9kdWxlLmV4cG9ydHMgPSBfX3dlYnBhY2tfcHVibGljX3BhdGhfXyArICJpbWcvbWlzdG9ja3doaXRlLmQ2ODRlOGY5LnBuZyI7"